import { ScenePointLight } from '../lights/ScenePointLight';

import { BallsGLTF } from './BallsGLTF';
import { MachineGLTF } from './MachineGLTF';

/**
 * Machine:
 *  - 01 - one chamber,
 *  - 01 - one output,
 */
export class GMachine01_02_GLTF extends MachineGLTF {
    static get randomTimeToWait() {
        return 500;
    }

    static assets = {
        textures: [],
        balls: [],
        machine: 'gMachine01_02',
        file: '/models/gMachine01_02.glb',
    };

    constructor(viewer, gltf, ballsGLTF) {
        super(viewer, gltf, GMachine01_02_GLTF.assets.machine, ballsGLTF, {
            cameraZOffset: 0.79,
            cameraYOffset: 0.1,
            topBallScale: 1.2,
            ballAnimationDuration: 3,
            gAnimationRowElements: 6,
            gAnimationRowStep: 0.059,
        });
    }

    static loadAssets(viewer, ballsGLTF) {
        MachineGLTF.loadAssetsFromAssets(viewer, GMachine01_02_GLTF.assets, ballsGLTF);
    }

    static loadModel(viewer) {
        const balls = MachineGLTF.ballsFromAssets(viewer, GMachine01_02_GLTF.assets);

        const machine = new GMachine01_02_GLTF(viewer, viewer.getGLTF(GMachine01_02_GLTF.assets.machine), balls);
        viewer.addModel(machine);

        viewer.addModel(
            new ScenePointLight(
                viewer,
                'PointLight01',
                machine.gltf.scene.getObjectByName('PointLight01').position.clone().add(machine.gltf.scene.position)
            )
        );
    }

    animationUpdate(animation) {
        const action = this.mixer.clipAction(animation);
        action.startAt(BallsGLTF.animationOffset);
        action.play();
    }

    ballAnimation() {
        super.ballAnimation();
        super.gAnimateBallFromAssets(GMachine01_02_GLTF.assets.balls, GMachine01_02_GLTF.randomTimeToWait);
    }
}
